
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/[_name]",
      function () {
        return require("private-next-pages/stories/[_name].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/[_name]"])
      });
    }
  